// Per-user data-element preferences (cross-backend → admin-corev2).
// GET/POST /user/user-data-element. Matches admin-ui's userDataElement.js
// `.index({params})` / `.create(payload)` used by use-user-data-element + the
// notification data-element modal.
import { adminRequest } from './client.js';

function toQuery(params) {
	if (!params) return '';
	if (typeof params === 'string') return params ? `?${params}` : '';
	const qs = new URLSearchParams(params).toString();
	return qs ? `?${qs}` : '';
}

const api = {
	index: ({ params } = {}) => adminRequest('GET', `/user/user-data-element${toQuery(params)}`),
	create: (payload) => adminRequest('POST', '/user/user-data-element', payload),
};

export default api;
